import { CheckCircle2, Clock } from 'lucide-react';

export const dateFR = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : '');

export const modeCharte = (charte) => (charte?.mode === 'lettre_mission' ? 'via la lettre de mission' : 'par signature électronique');

export const StatutCharte = ({ charte }) => (charte ? (
  <div className="mt-6 flex items-start gap-3 rounded-xl bg-[#8DC63F]/15 px-4 py-3 text-sm" data-testid="ma-charte-statut-signee">
    <CheckCircle2 className="h-5 w-5 shrink-0 text-[#8DC63F]" />
    <span>
      Charte acceptée le <b data-testid="ma-charte-date">{dateFR(charte.date_signature)}</b> {modeCharte(charte)}.
      Rien d'autre à faire.
    </span>
  </div>
) : (
  <div className="mt-6 flex items-start gap-3 rounded-xl bg-amber-400/15 px-4 py-3 text-sm" data-testid="ma-charte-statut-a-signer">
    <Clock className="h-5 w-5 shrink-0 text-amber-300" />
    <span>Vous n'avez pas encore signé la charte. Lisez-la puis signez en bas de page (une seule fois).</span>
  </div>
));
